import { render, staticRenderFns } from "./EditController.vue?vue&type=template&id=eb731096&"
import script from "./EditController.vue?vue&type=script&lang=js&"
export * from "./EditController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports